import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'app.modules.chat.pages.chat.title',
    defaultMessage: 'Ayuda en línea',
  },
  chatWindowTitle: {
    id: 'app.modules.chat.pages.chat.window.title',
    defaultMessage: 'PedidosYa Chat',
  },
});
